"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasScrollLock = void 0;

// State
// --------------------------------------------------------
// Utility functions for setting styles based on component state.
// Classes are prepended with `is-` or `has-`.
const hasScrollLock = () => `
  &.has-scroll-lock {
    position: absolute;
    width: 100%;
    overflow: hidden;
  }
`;

exports.hasScrollLock = hasScrollLock;